module.exports = __webpack_public_path__ + "assets/c03b0d32dfcdcc935af1f2f8a45cf539.svg";